type ClientMutationPayload = {
  errors?: string[] | null
  result?: string | null
}

type ClientMutationResult = {
  error?: { message?: string } | string | null
  data?: Record<string, ClientMutationPayload | null> | null
}

/**
 * Returns a user-facing error message for a urql mutation result, or null on success.
 * Safe when data.<fieldName> is null (GraphQL field failure without a CombinedError).
 */
export function clientMutationFailureMessage(
  result: ClientMutationResult | null | undefined,
  fieldName: string,
  fallback = "Something went wrong. Please try again."
): string | null {
  const payload = result?.data?.[fieldName]
  const fieldErrors = payload?.errors
  const hasFieldErrors = Array.isArray(fieldErrors) && fieldErrors.length > 0
  const failed = Boolean(result?.error) || !payload || hasFieldErrors || payload.result === "failure"
  if (!failed) return null

  if (result?.error) {
    if (typeof result.error === "string") return result.error
    return result.error.message || String(result.error)
  }
  if (hasFieldErrors) return fieldErrors.join(", ")
  return fallback
}
